<template>
  <div class="preparation">
    <van-nav-bar title="全血/血清制备" v-if="isWx==1" left-arrow @click-left="onClickLeft" fixed></van-nav-bar>
    <van-nav-bar title="全血/血清制备" v-else fixed></van-nav-bar>
    <div class="navheight"></div>
    <div class="swine_wrap">
        <van-collapse v-model="activeNames">
            <van-collapse-item :title="index + 1 + '、' +item.title" :name="index" v-for="(item,index) in contentList" :key="index">
                <p>{{item.textItem}}</p>
                <div :style="item.list && item.list.length != 0 ? 'padding-top:10px;':''">
                    <p v-for="(ele,i) in item.list" :key="i" style="line-height:22px;">
                      <span style="font-weight: 600;display:block;">{{ele.title}}：</span>
                      <span style="color:#4C4C4C;">{{ele.textItem}}</span>
                    </p>
                </div>
            </van-collapse-item>
        </van-collapse>
    </div>
    <Top :btnFlag="btnFlag"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Top from '@/components/top.vue'
export default {
  name: 'preparation',
  components: {
    Top
  },
  data(){
    return{
      btnFlag:false,
      activeNames:[0],
      contentList:[
        {
          title:'全血',
          textItem:'全血也可称为抗凝血，是由静脉采集的血液与一定量抗凝剂混合的血液，主要是红细胞和血浆。在实验室检验中，许多检测项目要求抗凝血样本',
        },
        {
          title:'抗凝剂',
          list:[
            {title:'(1) 枸橼酸钠',textItem:'枸橼酸钠抗凝血，主要用于血液凝固项目检查，不适用于血液化验和生化测验。'},
            {title:'(2) EDTA',textItem:'PCR检测血样的首选抗凝剂。主要用于血液有形成分检查的全血，EDTA可抑制血小板聚集，不适用于凝血检查及血小板功能试验。'},
            {title:'(3) 肝素',textItem:'肝素抗凝血应在短时间内使用，否则放置过久血液又可疑固。适用于做红细胞渗适性试验、血气、血浆渗透量、红细胞压积及普通生化测定。不适合做血凝试验、白细胞分类和血小板计数检验。此外，肝素抗凝血不能用于制作血涂片，因为瑞氏染色后会出现深蓝色背景。'},
            {title:'(4) 草酸盐',textItem:'此种抗凝剂溶解度大，抗凝作用强。因草酸盐与血液中钙离子结合生成草酸钙沉淀，可使血细胞形态发生变化，故不宜制作血涂片检查。不能用作血小板计数和尿素、血氨、非蛋白氮等含氮物质的检测。同时草酸盐也影响血液中某些成分的生物活性，故血液学中很少应用。'}
          ],
          textItem:'通过除去或抑制血液中某些凝血因子的活性来阻止血液凝固。实际应用中要根据不同的需要进行抗凝剂的选择，常用的抗凝剂有肝素、乙二胶四乙酸盐(EDTA盐)、枸橼酸钠、草酸盐等4种。',
        },
        {
          title:'血浆',
          textItem:'离开血管的全血经抗凝处理后，通过离心沉淀（或静置数小时），所获得的不含细胞成分的液体，即血浆。',
        },
        {
          title:'血清',
          textItem:'离体后未经抗凝处理的血液会自然凝固（或离心时），分离出上层淡黄色透明液体为血清。与血浆相比，血清缺少某些凝血因子，不可再凝。未参加凝血反应的物质与血浆基本相同。为了避免抗凝剂的干扰，有关血液的许多试验分析，都以血清为样品。',
        }
      ],
      browser: {
        trident: navigator.userAgent.indexOf('Trident') > -1, //IE内核
        presto: navigator.userAgent.indexOf('Presto') > -1, //opera内核
        webKit: navigator.userAgent.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
        gecko: navigator.userAgent.indexOf('Gecko') > -1 && navigator.userAgent.indexOf('KHTML') == -1, //火狐内核
        mobile: !!navigator.userAgent.match(/AppleWebKit.*Mobile.*/) || !!navigator.userAgent.match(/AppleWebKit/), //是否为移动终端
        ios: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
        android: navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Linux') > -1, //android终端或者uc浏览器
        iPhone: navigator.userAgent.indexOf('iPhone') > -1 || navigator.userAgent.indexOf('Mac') > -1, //是否为iPhone或者QQHD浏览器
        iPad: navigator.userAgent.indexOf('iPad') > -1, //是否iPad
        webApp: navigator.userAgent.indexOf('Safari') == -1 //是否web应该程序，没有头部与底部
      },
      isWx:1,
    }
  },
  
  created(){
    const ua = window.navigator.userAgent.toLowerCase();
    if(ua.indexOf('micromessenger') == -1) {
      this.isWx = 1
    }else{
      this.isWx = 2
    }
  },
  methods: {
    onClickLeft() {
      this.$router.back(-1)
    },
  }
}
</script>

<style lang="scss">
.preparation{
    text-align: left !important;
    .van-nav-bar .van-icon{
        color: #999999;
    }
    .van-cell{
      color:#4C4C4C !important;
      font-size:16px !important;
    }
    .van-collapse-item__content{
      color:#4C4C4C !important;
      font-size:14px !important;
      background:rgba(245,245,245,1) !important;
    }
    .content{
        padding: 15px 14px 10px;
        font-family:PingFangSC-Regular;
        line-height:24px;
        color:rgba(32,32,32,1);
        opacity:1;
    }
}
.van-button--normal {
  width: 40%;
  margin: 10px;
}
.navheight {
  height: 46px;
}
</style>
